const getProducts = async (
  axiosprivate: any,
  currentpage: number,
  limit: number,
  auth: any,
) => {
  const response = await axiosprivate.get(
    `bp_employee_get_all_products_information?page=${currentpage}&limit=${limit}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

const getProductsNames = async (axiosprivate: any, auth: any) => {
  const response = await axiosprivate.get(`bp_employee_get_all_product_names`, {
    headers: { Authorization: 'Bearer ' + auth?.accessToken },
  });
  return response;
};

const getSubCategories = async (axiosprivate: any, auth: any) => {
  const response = await axiosprivate.get(
    `bp_employee_get_all_sub_categories_information`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};
const getSearchedProducts = async (
  axiosprivate: any,
  search: string,
  currentpage: number,
  searchlimit: number,
  auth: any,
) => {
  const response = await axiosprivate.get(
    `bp_employee_search_all_products_information?bp_search_text=${search}&page=${currentpage}&limit=${searchlimit}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

const getProductsBySubCategory = async (
  axiosprivate: any,
  subcategory: string,
  currentpage: number,
  limit: number,
  auth: any,
) => {
  const response = await axiosprivate.get(
    `bp_employee_get_product_by_sub_category/${subcategory}?page=${currentpage}&limit=${limit}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

export interface BarcodeMatchedVariant {
  _id: string;
  bp_variant_sku?: string;
  bp_variant_attributes?: Record<string, string>;
  bp_variant_barcode?: string;
  bp_variant_selling_price?: number;
  bp_variant_quantity?: number;
}

export interface ProductByBarcodeResponseData {
  _id: string;
  bp_product_name?: string;
  bp_product_has_variants?: boolean;
  bp_product_variants?: Array<Record<string, any>>;
  bp_matched_variant?: BarcodeMatchedVariant;
  [key: string]: any;
}

// Variant-aware barcode lookup:
// - Root barcode match: response is unchanged.
// - Variant barcode match: response includes `data.bp_matched_variant`.
const getProductsByBarcode = async (
  axiosprivate: any,
  barcode: string,
  auth: any,
) => {
  const response = await axiosprivate.get(
    `bp_employee_get_product_by_barcode?barcode=${encodeURIComponent(barcode)}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

const getProductByIDs = async (
  axiosprivate: any,
  productIds: string[],
  auth: any,
) => {
  const response = await axiosprivate.post(
    `bp_employee_get_products_by_ids`,
    JSON.stringify({
      productIds: productIds,
    }),
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

const buildProductStreamUrl = (
  baseUrl: string,
  accessToken: string,
  locationId: string,
) => {
  const root = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const params = [
    `token=${encodeURIComponent(accessToken)}`,
    `location_id=${encodeURIComponent(locationId)}`,
  ];

  return `${root}/bp_employee_product_stream?${params.join('&')}`;
};

export {
  getProducts,
  getSubCategories,
  getProductsNames,
  getSearchedProducts,
  getProductByIDs,
  getProductsByBarcode,
  getProductsBySubCategory,
  buildProductStreamUrl,
};

// Placeholder: Owner updates full product details within POS app
export const updateEmployeeProductDetails = async (
  axiosprivate: any,
  employeeId: string,
  productId: string,
  payload: any,
  auth: any,
) => {
  const response = await axiosprivate.patch(
    `bp_employee_update_product_details/${encodeURIComponent(
      employeeId,
    )}/${encodeURIComponent(productId)}`,
    JSON.stringify(payload),
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

// Update a single product's favourite state for an employee
// Expects backend endpoint to accept product id and desired favourite boolean
export const updateEmployeeProductFavourite = async (
  axiosprivate: any,
  productId: string,
  favourite: boolean,
  auth: any,
) => {
  const response = await axiosprivate.patch(
    `bp_employee_update_product_favourite`,
    JSON.stringify({
      bp_product_id: productId,
      bp_product_is_favourite: favourite,
    }),
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};
